export const formatNamePart = (value = "") =>
  value
    .trim()
    .split(/\s+/u)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(" ");

export const buildFullName = (lastName, firstName) =>
  [formatNamePart(lastName), formatNamePart(firstName)].filter(Boolean).join(" ").trim();

export const sanitizePhone = (value = "") => value.replace(/\D+/gu, "");

export const sanitizeCnp = (value = "") => value.replace(/\D+/gu, "").slice(0, 13);
